export const Teksten = {
  login: {
    auth: {
      header: "Aanleverloket",
      text: "Start met publiceren",
      id: "nav_aanleveren_btn",
      title: "Start hier met het publiceren van uw documenten.",
      intro: [
        "U bent ingelogd in het aanleverloket van de Kamerstukkenmodule. Hier kunt u dossiers en documenten uploaden, wijzigen en intrekken.",
        "U bent ingelogd in het aanleverloket van de Kamerstukkenmodule. Hier kunt u documenten publiceren, wijzigen of intrekken.",
      ],
    },
    nietAuth: {
      header: "Aanleverloket",
      text: "Inloggen",
      id: "inloggen",
      title: "Log in om documenten te publiceren.",
      intro: [
        "Welkom bij het aanleverloket van de Kamerstukkenmodule.",
        "Hier kunt u Kamerstukken en publieke informatie aanleveren die vindbaar wordt gemaakt voor burgers zoals omschreven in de Wet open overheid.",
        " Log in met uw account om voor uw overheidsorganisatie documenten actief openbaar te maken.",
      ],
    },
    storing: {
      header: "Mededeling",
    },
  },
  publicatie: {
    title: "Publicaties",
    alinia: [
      {
        tekst: ["De ingevoerde overheidsdocumenten worden gepubliceerd op open.overheid.nl en rijksoverheid.nl"],
      },
    ],
  },
  hulp: {
    title: "Hulp en contact",
    alinia: [
      {
        tekst: ["Heeft u nog vragen?", "Mail dan naar servicedesk@koop.overheid.nl "],
      },
      {
        tekst: ["Vermeld s.v.p. in de mail dat het om de nieuwe Kamerstukkenmodule gaat."],
      },
    ],
  },
  intrekken: {
    document: {
      title: "Reden voor intrekken",
      tekst: "U staat op het punt om dit document in te trekken.",
      id: "reden",
      label: "Vul hier de reden in:",
      placeholder: "Reden voor intrekken",
    },
    dossier: {
      title: "Weet u zeker dat u dit dossier wilt intrekken?",
      tekst: "Het dossier wordt ingetrokken en kan daarna niet meer worden aangepast.",
      warning: "Bij het intrekken van dit dossier worden de bijgevoegde documenten niet ingetrokken.",
    },
  },
  dossierAnnuleren: {
    title: "Weet u zeker dat u het aanmaken van dit dossier wilt annuleren?",
    tekst: "Het dossier wordt geannuleerd en kan daarna niet meer worden aangepast.",
    alert: "Bij het annuleren van dit dossier worden de bijgevoegde documenten verwijderd.",
  },
  createScreen: {
    dpcupload: {
      tekst: "Dit bestand kan niet verwijderd worden. U kunt wel de metadata of het bestand aanpassen.",
    },
    document: {
      tooltipFile: [
        "Kies een bestand van uw computer. Na verwerking wordt het bestand gepubliceerd op open.overheid.nl.",
      ],
      tooltipWeblocatie: [
        "Voer een geldige link in naar een document op een andere website. Zorg dat de link begint met https:// en naar een bestaand document verwijst.",
      ],
    },
    publisher: {
      id: "publisher",
      label: "Publicerende organisatie",
      placeholder: "Publicerende organisatie",
      tooltip: [
        "Vul de overheidsorganisatie in die de wettelijke verantwoordelijkheid draagt voor de actieve openbaarmaking van het document.",
      ],
    },
    dossierhouder: {
      id: "dossierhouder",
      label: "Dossierhouder",
      placeholder: "Kies organisatie",
      tooltip: ["Vul de overheidsorganisatie in die de verantwoordelijkheid draagt voor het dossier."],
    },
    dossiertype: {
      id: "dossiertype",
      label: "Dossiertype",
      placeholder: "Kies dossiertype",
      tooltip: ["Vul hier het dossiertype in."],
    },
    documentrelatie: {
      label: "Documentrelatie",
      id_veld1: "documentrelatie_soort",
      id_veld2: "documentrelatie_titel",
      tooltip: ["Vul hier de relatie in die het document heeft met een ander gepubliceerd document."],
    },
    documentstatus: {
      id: "documentstatus",
      label: "Documentstatus",
      tooltip: ["Dit is de status van de verwerking van het document binnen open.overheid.nl"],
    },
    aanleverdatum: {
      id: "aanleverdatum",
      label: "Aanleverdatum",
      tooltip: ["Dit is de datum waarop het document (dus het bestand plus de metadata) is aangeleverd."],
    },
    laatstBewerkt: {
      id: "laatst_bewerkt",
      label: "Laatst bewerkt",
      tooltip: ["Dit is de datum waarop de metadata of het bestand zelf zijn gewijzigd."],
    },
    titel: {
      id: "titel",
      label: "Titel",
      placeholder: "Vul de titel van het document in",
      placeholderDossier: "Vul de titel van het dossier in",
      tooltip: [
        "Dit is de titel die op open.overheid.nl wordt getoond bij het document. De titel beschrijft het document op een manier die duidelijk is voor de gebruiker van open.overheid.nl.",
      ],
    },
    rijksoverheid: {
      id: "rijksoverheid",
      label: "Publiceert u namens een ministerie?",
      tooltip: [
        "Alle documenten worden gepubliceerd op de Woo-voorziening/open.overheid.nl. Publiceert u documenten namens een ministerie en heeft uw organisatie afspraken met Dienst Publiek en Communicatie (DPC), kies dan 'ja'.",
      ],
    },
    documentsoort: {
      id: "documentsoort",
      label: "Documentsoort",
      placeholder: "Selecteer een documentsoort",
      tooltip: [
        "Selecteer het type document dat u wilt publiceren, zoals beleidsstukken, besluiten, vergaderstukken, onderzoeksrapporten of Woo-besluiten. Kies de optie die het beste past bij het document. Dit helpt gebruikers bij het filteren van zoekresultaten en geeft inzicht in de aard van het document.",
      ],
    },
    informatiecategorieen: {
      id: "Woo-informatiecategorie",
      label: "Woo-informatiecategorie",
      placeholder: "Selecteer de informatie categorie van dit document",
      tooltip: [
        "Kies de categorie die het type informatie van dit document het best beschrijft, volgens de Woo-standaarden.",
        "Mocht u geen keuze kunnen maken, gelieve ‘inspanningsverplichting art 3.1 Woo’ te selecteren.",
      ],
    },
    identifier: {
      id: "identifier",
      label: "Identificatiekenmerk",
      placeholder: "Voer kenmerk of documentnummer in (min. 3 karakters)",
      tooltip: [
        "Vul hier het identificatiekenmerk van het document in (min. 3 karakters). Deze wordt door de aanleverende organisatie zelf aan het document toegekend, en moet binnen de aanleverende organisatie uniek zijn.",
      ],
    },
    documenthandeling: {
      label: "Documenthandeling",
      tooltip: [
        "De documenthandeling geeft aan op welke datum een officiële handeling met betrekking tot het document heeft plaatsgevonden.",
        "Documenthandelingen zijn samengesteld uit een organisatie die deze handeling heeft uitgevoerd, een handeling en de datum.",
      ],
    },
    wasAssociatedWith: {
      id: "wasAssociatedWith",
      placeholder: "Kies een organisatie",
    },
    soortHandeling: {
      id: "soortHandeling",
      placeholder: "Kies een handeling",
    },
    atTime: {
      id: "atTime",
    },
    taal: {
      id: "taal",
      label: "Taal",
      placeholder: "Kies de taal",
      tooltip: ["Kies de taal waarin het document is geschreven."],
    },
    uitgesteld: {
      id: "uitgesteld",
      label: "Uitgesteld publiceren",
    },
    uitgesteld_tooltip: {
      id: "uitgesteld_publiceren_tooltip",
      tooltip: ["Vul hier het moment in vanaf wanneer het document mag worden gepubliceerd."],
    },
    concept: {
      id: "concept",
      label: "Opslaan als concept",
    },
    concept_tooltip: {
      id: "concept_publicatie_tooltip",
      tooltip: [
        "Upload de gehele set als concept. Concepten worden niet gepubliceerd en kunnen later gemarkeerd worden als niet concept.",
      ],
    },
    uitsteldatum: {
      id: "uitsteldatum",
      placeholder: "Selecteer datum",
    },
    uitsteltijd: {
      id: "uitsteltijd",
      placeholder: "Selecteer tijd",
    },
    verantwoordelijke: {
      id: "verantwoordelijke",
      label: "Verantwoordelijke organisatie",
      placeholder: "Selecteer de verantwoordelijke organisatie",
      tooltip: [
        "Selecteer de overheidsorganisatie die de wettelijke verantwoordelijkheid draagt voor de inhoud/strekking van het document.",
      ],
    },
    medeverantwoordelijken: {
      id: "medeverantwoordelijken",
      label: "Medeverantwoordelijke organisaties",
      placeholder: "Selecteer één of meer medeverantwoordelijke organisaties",
      tooltip: [
        "Vul de overheidsorganisatie(s) in die medeverantwoordelijk is/zijn voor de inhoud/strekking van het document",
      ],
    },
    naam: {
      id: "naam",
      label: "Naam (key)",
      placeholder: "Vul hier de naam in",
      tooltip: [
        "Organisaties kunnen ook eigen, domeinspecifieke metadata gebruiken.",
        "Alle metadata bestaan uit key-value pairs: een veldnaam (key) en een waarde (value). Bij elke waarde moet een key gedefinieerd zijn. Het aantal key-value pairs is onbeperkt.",
        "Bijvoorbeeld: key = “verantwoordelijke wethouder”, value = “wethouder van cultuur en welzijn”.",
      ],
    },
    waarde: {
      id: "waarde",
      label: "Waarde (value)",
      placeholder: "Vul de bijbehorende waarde in",
      tooltip: [
        "Organisaties kunnen ook eigen, domeinspecifieke metadata gebruiken.",
        "Alle metadata bestaan uit key-value pairs: een veldnaam (key) en een waarde (value). Bij elke waarde moet een key gedefinieerd zijn. Het aantal key-value pairs is onbeperkt.",
        "Bijvoorbeeld: key = “verantwoordelijke wethouder”, value = “wethouder van cultuur en welzijn”.",
      ],
    },
    onderwerpen: {
      id: "onderwerpen",
      label: "Onderwerp",
      placeholder: "Vul hier één of meerdere onderwerpen in",
      tooltip: [
        "Vul in één of enkele woorden in waar het document over gaat. Een onderwerp kan bijvoorbeeld zijn ‘Ingestelde sancties tegen Frankrijk’.",
      ],
    },
    onderwerpenRonl: {
      id: "onderwerpenRonl",
      label: "Onderwerpen Rijksoverheid.nl",
      placeholder: "Selecteer één of meerdere onderwerpen voor gebruik op Rijksoverheid.nl",
      tooltip: [
        "Vul deze onderwerpen alleen in als de geüploade documenten gepubliceerd moeten worden op Rijksoverheid.nl. Voor de ordening van documenten op Rijksoverheid.nl wordt een specifieke lijst met onderwerpen gebruikt. Bekijk Rijksoverheid.nl voor meer informatie.",
      ],
    },
    thema: {
      id: "thema",
      label: "Thema's",
      placeholder: "Selecteer één of meerdere thema's",
      tooltip: [
        "Om documenten te kunnen ordenen naar een globaal onderwerp wordt gebruik gemaakt van een themalijst. Een document kan onder meerdere thema’s vallen.",
      ],
    },
    omschrijving: {
      id: "omschrijving",
      label: "Omschrijving document",
      labelDossier: "Omschrijving dossier",
      placeholder: "Vul een omschrijving in (min. 3 karakters)",
      tooltip: [
        "Beschrijf hier in enkele zinnen waar het document over gaat. De omschrijving verbetert de vindbaarheid van het document op open.overheid.nl en wordt op rijksoverheid.nl gebruikt als inleidende tekst bij het document.",
      ],
    },
    verkorteTitels: {
      id: "verkorteTitels",
      label: "Verkorte titel",
      placeholder: "Vul een verkorte titel in (min. 3 karakters)",
      tooltip: ["Geef hier een verkorte aanduiding  (min. 3 karakters) van een mogelijk veel langere officiële titel."],
    },
    alternatieveTitels: {
      id: "alternatieveTitels",
      label: "Alternatieve titel",
      placeholder: "Vul alternatieve titel in (min. 3 karakters)",
      tooltip: [
        "Geef hier een alternatieve titel (min. 3 karakters). Zorg ervoor dat deze anders is dan de officiële of verkorte titel.",
        "Het vullen van dit veld verbetert de vindbaarheid van het document op open.overheid.nl.",
      ],
    },
    naamOpsteller: {
      id: "naamOpsteller",
      label: "Naam opsteller",
      placeholder: "Vul de naam in (min. 3 karakters)",
      tooltip: [
        "Vul hier de organisatie in die het document initieel heeft gemaakt. Dit hoeft geen overheidsorganisatie te zijn, maar kan bijvoorbeeld ook een adviesbureau of de naam van een persoon zijn.",
      ],
    },
    creatiedatum: {
      id: "creatiedatum",
      label: "Creatiedatum",
      placeholder: "Vul een datum, maand of jaartal in",
      tooltip: [
        "Vul hier de datum in waarop het document initieel is gemaakt. Deze datum kan op de dag nauwkeurig zijn, maar ook een maand of jaar aanduiden.",
      ],
    },
    geldigheid: {
      label: "Geldigheid",
      tooltip: [
        "Vul hier de periode in waarbinnen het document geldig is.",
        "De geldigheid kan gebruikt worden om aan te geven dat een document niet meer geldig is, bijvoorbeeld omdat het door een ander document is vervangen. Het document zal dan niet worden verwijderd, maar het is wel duidelijk dat het niet meer geldig is.",
      ],
    },
    begindatum: {
      id: "begindatum",
      placeholder: "Selecteer begindatum",
    },
    einddatum: {
      id: "einddatum",
      placeholder: "Selecteer einddatum",
    },
    aggregatiekenmerk: {
      id: "aggregatiekenmerk",
      label: "Aggregatiekenmerk",
      placeholder: "Voer aggregatiekenmerk in",
      tooltip: [
        "Vul hier de door aanleverende organisatie aangedragen tekst in, die een aantal documenten met elkaar gemeen kunnen hebben.",
      ],
    },
    reden: {
      id: "reden",
      label: "Vul hier de reden in:",
      placeholder: "Voer reden voor intrekken of vervangen in",
      tooltip: ["Vul hier de reden in, waarom een document is ingetrokken of vervangen."],
    },
  },
  over: {
    titel: "Meer informatie over het aanleverloket",
    alinia: [
      {
        titel: "De Kamerstukkenmodule",
        tekst: [
          "Het aanleverloket van de Kamerstukkenmodule kan worden gebruikt voor het actief openbaar maken van overheidsdocumenten. Documenten kunnen via het aanleverloket handmatig worden gepubliceerd. ",
          "De gepubliceerde documenten worden vervolgens verwerkt en getoond op de website open.overheid.nl. ",
          "Ook biedt de Kamerstukkenmodule de mogelijkheid om Kamerstukken en niet-Kamerstukken openbaar",
          " te maken op de website Rijksoverheid.nl.",
        ],
      },
      {
        titel: "Hulp",
        tekst: [
          "Ik heb per ongeluk het verkeerde document geüpload in het aanleverloket van de Kamerstukkenmodule, wat nu? ",
          "In het aanleverloket van de Kamerstukkenmodule is het mogelijk om bestanden te bewerken, in te trekken en/of opnieuw te publiceren. ",
        ],
        linkTekst: "Meer uitleg over het aanleverloket staat beschreven in de ",
      },
      {
        titel: "Contact",
        tekst: [
          "Voor vragen of meer informatie kunt u mailen naar servicedesk@koop.overheid.nl. ",
          "Vermeld s.v.p. in de mail dat het om de nieuwe Kamerstukkenmodule gaat.",
        ],
      },
    ],
  },
};
